import React from "react";
import { Text, Flex, Image } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { valueFormatTimeConvertLetters } from '../../../helpers/dateTime';
import { getStatusIcon } from "../../../pages/CallAssistant/controller";

const AgentStatus = (props) => {
    const { statusCode, statusChangeTime, reasonCode } = props;

    const statusIcon = getStatusIcon(statusCode.code);

    const calculateTimerValue = (time) => {
        let callTime = Math.floor((Date.now() - new Date(time)) / 1000);
        if (callTime < 0) {
            // Don't allow negative times
            callTime = 0;
        }
        return valueFormatTimeConvertLetters(callTime.toString());
    }

    return (
        <Flex data-testid="rowAgentStatus" vAlign="center" gap="gap.smaller">
            <Flex>
                <Image as={statusIcon} />
            </Flex>
            <Text>{statusCode.description + (reasonCode ? ' - ' + reasonCode.description : '') + ' - ' + calculateTimerValue(statusChangeTime)}</Text>
        </Flex>
    );
};

AgentStatus.propTypes = {
    statusCode: PropTypes.object,
    statusChangeTime: PropTypes.string,
};

AgentStatus.defaultProps = {
    statusCode: {},
    statusChangeTime: '',
};

export default AgentStatus;
